import { c as _c } from "react/compiler-runtime";
import { HotelSearchWrapper } from "@website/accommodation-ui/hotel-search/hotel-search-wrapper";
import { VillaSearchPanel } from "@website/accommodation-ui/villa-search/villa-search-panel";
import { VillaSearchSummary } from "@website/accommodation-ui/villa-search/villa-search-summary";
import { VillaSearchPropertiesType } from "@website/accommodation-ui/villa-search/villa-search.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { useFilters } from "@website/widget/filter";
import { useRouter } from "next/router";
import { FC } from "react";
export const VillaSearch: FC<VillaSearchPropertiesType> = properties => {
  const $ = _c(34);
  const {
    isSearchPanelOpen,
    setIsSearchPanelOpen,
    searchPanelProperties,
    searchSummaryProperties,
    disableSticky,
    searchType: t0,
    filterProps,
    isNewPlP
  } = properties;
  const searchType = t0 === undefined ? "city" : t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router.pathname) {
    t1 = router.pathname?.includes("map");
    $[0] = router.pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMapPage = t1;
  let t2;
  if ($[2] !== filterProps?.schema) {
    t2 = filterProps?.schema ?? {};
    $[2] = filterProps?.schema;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      schema: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    selectedFiltersCount
  } = useFilters(t3);
  const hasSelectedFilters = selectedFiltersCount > 0;
  let t4;
  if ($[6] !== filterProps?.toggleFilterModal || $[7] !== hasSelectedFilters || $[8] !== isMapPage) {
    t4 = isMapPage && <Button className="!ms-4 block !size-8 shrink-0 !overflow-visible md:!hidden" color={hasSelectedFilters ? "secondary" : "neutral"} onClick={filterProps?.toggleFilterModal} variant="text"><span className="relative flex size-8 items-center justify-center">{hasSelectedFilters && <span className="bg-secondary absolute -left-0.5 top-0 size-[8px] rounded-full" />}<MaterialIcon className="text-headline-5" name="tune" /></span></Button>;
    $[6] = filterProps?.toggleFilterModal;
    $[7] = hasSelectedFilters;
    $[8] = isMapPage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== searchPanelProperties || $[11] !== searchType) {
    t5 = <VillaSearchPanel {...searchPanelProperties} searchType={searchType} />;
    $[10] = searchPanelProperties;
    $[11] = searchType;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== searchSummaryProperties || $[14] !== searchType) {
    t6 = <VillaSearchSummary {...searchSummaryProperties} searchType={searchType} />;
    $[13] = searchSummaryProperties;
    $[14] = searchType;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== disableSticky || $[17] !== isNewPlP || $[18] !== isSearchPanelOpen || $[19] !== searchType || $[20] !== setIsSearchPanelOpen || $[21] !== t5 || $[22] !== t6) {
    t7 = <div className="min-w-0 flex-1"><HotelSearchWrapper PanelElement={t5} SummaryElement={t6} disableSticky={disableSticky} isSearchPanelOpen={isSearchPanelOpen} isNewPlP={isNewPlP} searchType={searchType} setIsSearchPanelOpen={setIsSearchPanelOpen} /></div>;
    $[16] = disableSticky;
    $[17] = isNewPlP;
    $[18] = isSearchPanelOpen;
    $[19] = searchType;
    $[20] = setIsSearchPanelOpen;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const t8 = `${isMapPage ? "!me-6 block size-[18px] shrink-0 md:!hidden" : "!hidden"}`;
  const t9 = filterProps?.closeMapHref;
  const t10 = filterProps?.onCloseMap;
  const t11 = filterProps?.closeMapHref ? "link" : undefined;
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <MaterialIcon className="text-headline-5" name="close" />;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t8 || $[28] !== t9) {
    t13 = <Button className={t8} color="neutral" href={t9} onClick={t10} role={t11} type="button" variant="text">{t12}</Button>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t8;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t4 || $[32] !== t7) {
    t14 = <div><div className="flex flex-row items-center gap-0 bg-white">{t4}{t7}{t13}</div></div>;
    $[30] = t13;
    $[31] = t4;
    $[32] = t7;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
};